module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABY0lEQVR4AWIYBYBmyiKrwSAIwkvkAjhcZfaRLbKacAFsH70Hegp09uhR+pEl1kzhNDKaN/nfq3j++lpqXBdVZ1W/Nmf69XmyYineXP1dWw3D61onmd9WZ1vS0A0gtK7bcZXX5jQMIgEkhAoGQNuzAWw0TDgADPIBUPj8sXSZAKCiI0Ai4uKXbwl1ZAznC8VQxrG2YAIBCG3nLcQv8TpYYmVl9laY9peZpd5/N3l8r6ZOnsz0yRNZMV5PHj3oJPO9JW4Jw18BJk8fWzD9Vcf3cSPYWWINA5dQpTSVmjxmFdN64wOAVrsA8JtgAA9zCAY+omAALJ0nAPlAhAMUHgGWUPkAIH4ugOg4HpSKoYzjf+N4/x2q/DIOwmt0J/kkHL3pqbGbnhm/6ZEVSyUb/G/ebUlDqUGaaxgUA0DbiwIIoyIANPQjwG8Gt4QXbeUCwKIWiiHMO5EnXEQcv4yD8BqHU677PwMP4q2FzfVzuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/figma_logo.png
// module id = AmTM
// module chunks = 2